/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineBookingPlacementRsDto } from './traveline-booking-placement-rs-dto';
import {
    TravelineBookingPlacementRsDtoFromJSON,
    TravelineBookingPlacementRsDtoFromJSONTyped,
    TravelineBookingPlacementRsDtoToJSON,
    TravelineBookingPlacementRsDtoToJSONTyped,
} from './traveline-booking-placement-rs-dto';

/**
 * Room type entity
 * @export
 * @interface TravelineBookingRoomTypeRsDto
 */
export interface TravelineBookingRoomTypeRsDto {
    /**
     * Room type ID
     * @type {string}
     * @memberof TravelineBookingRoomTypeRsDto
     */
    id: string;
    /**
     * Accommodations entity
     * @type {Array<TravelineBookingPlacementRsDto>}
     * @memberof TravelineBookingRoomTypeRsDto
     */
    placements: Array<TravelineBookingPlacementRsDto>;
    /**
     * Category name
     * @type {string}
     * @memberof TravelineBookingRoomTypeRsDto
     */
    name: string;
}

/**
 * Check if a given object implements the TravelineBookingRoomTypeRsDto interface.
 */
export function instanceOfTravelineBookingRoomTypeRsDto(value: object): value is TravelineBookingRoomTypeRsDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('placements' in value) || value['placements'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function TravelineBookingRoomTypeRsDtoFromJSON(json: any): TravelineBookingRoomTypeRsDto {
    return TravelineBookingRoomTypeRsDtoFromJSONTyped(json, false);
}

export function TravelineBookingRoomTypeRsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingRoomTypeRsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'placements': ((json['placements'] as Array<any>).map(TravelineBookingPlacementRsDtoFromJSON)),
        'name': json['name'],
    };
}

  export function TravelineBookingRoomTypeRsDtoToJSON(json: any): TravelineBookingRoomTypeRsDto {
      return TravelineBookingRoomTypeRsDtoToJSONTyped(json, false);
  }

  export function TravelineBookingRoomTypeRsDtoToJSONTyped(value?: TravelineBookingRoomTypeRsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'placements': ((value['placements'] as Array<any>).map(TravelineBookingPlacementRsDtoToJSON)),
        'name': value['name'],
    };
}

